import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IPO_Shipment from "../models/IPO_Shipment";

interface CreatePOShipmentApiResponse {
    success: boolean;
    poShipment: IPO_Shipment;
    message?: string;
}

const createPOShipment = async (
    purchaseOrderGuid: string,
    vendorSourceId: number,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<CreatePOShipmentApiResponse> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.CreatePOShipment,
        params: { purchaseOrderGuid },
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
    });

    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({
            purchaseOrderGuids: [purchaseOrderGuid],
            poShipment: {
                vendor_source_id: vendorSourceId,
            },
        }),
    });

    if (!response.ok) {
        throw new Error(`Failed to create PO shipment: ${response.statusText}`);
    }

    return response.json();
};

interface DeletePOShipmentApiResponse {
    success: boolean;
    message?: string;
}

const deletePOShipment = async (
    purchaseOrderGuid: string,
    shipmentGuid: string,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<DeletePOShipmentApiResponse> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.DeletePOShipment,
        params: { purchaseOrderGuid, shipmentGuid },
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
    });

    // No throw on !response.ok: 404/409 bodies carry the guard message for the notification
    const response = await fetch(url, {
        method: "DELETE",
        headers,
    });

    return response.json();
};

const PurchaseOrderService = {
    createPOShipment,
    deletePOShipment,
};

export default PurchaseOrderService;
